import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Progress,
  Tooltip,
  Button
} from '@lockerpm/design';

import itemsComponents from '../../components/items';

import common from '../../utils/common';

import { CipherType } from '../../web-sh/src/core-js/src/enums';

function SidebarBottom(props) {
  const { CloudImageIcon } = itemsComponents;
  const { t } = useTranslation();
  const { collapsed, showBottom, setShowBottom = () => {} } = props;

  const planLimit = useSelector((state) => state.payment.planLimit)
  const plan = useSelector((state) => state.payment.plan)
  const userInfo = useSelector((state) => state.auth.userInfo)

  useEffect(() => {
    common.getPlanLimit();
    if (common.isFreePlan() && !common.isEnterpriseMember()) {
      setShowBottom(true);
    } else {
      setShowBottom(false);
    }
  }, [plan, userInfo])

  const storagePercentage = useMemo(() => {
    if (planLimit?.plan_limit) {
      const limit = planLimit?.plan_limit || {};
      const ciphers = planLimit?.ciphers || {};
      const addresses = planLimit?.relay_addresses || {};
      const totalItems = (ciphers?.total || 0) + (addresses?.total || 0);
      const totalLimit = (limit?.limit_total || 0) + (limit[CipherType.TOTP] || 0) + (limit?.relay_addresses || 0);
      return totalItems / totalLimit
    }
    return 0;
  }, [planLimit])

  return (
    <div className="admin-layout-sidebar-bottom">
      {
        showBottom && <Tooltip title={collapsed ? t('sidebar.plan_storage') : ''} placement='right' >
          <Button
            type='text'
            className="p-2"
            style={{ height: 'auto', width: '100%' }}
            onClick={() => common.clickSettingPlansBilling()}
          >
            <div>
              <div className={`flex items-center ${collapsed ? 'justify-center' : ''}`}>
                <CloudImageIcon
                  name="flash-success"
                  width={24}
                  height={24}
                />
                {
                  !collapsed && <p className='ml-2 font-semibold'>{t('sidebar.plan_storage')}</p>
                }
              </div>
              <Progress
                className='m-0'
                status={common.getPercentageStatus(storagePercentage)}
                showInfo={false}
                percent={storagePercentage * 100}
              />
            </div>
          </Button>
        </Tooltip>
      }
    </div>
  );
}

export default SidebarBottom;
